import React, { lazy } from 'react';
export function TestimonialsSection() {
  return <section className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#0f172a',
    borderColor: '#334155'
  }} data-id="element-573">
      <div className="max-w-3xl mx-auto" data-id="element-574">
        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-10 text-center" style={{
        color: '#f1f5f9'
      }} data-id="element-575">
          Testimonio Real
        </h2>

        <div className="rounded-lg overflow-hidden shadow-xl" style={{
        backgroundColor: '#1e293b',
        border: '1px solid #334155'
      }} data-id="element-576">
          <video controls playsInline webkit-playsinline="true" preload="none" className="w-full h-auto" style={{
          maxHeight: '80vh',
          objectFit: 'contain'
        }} data-id="element-577">
            <source src="https://ydgkmdmvhrniztrhtrxq.supabase.co/storage/v1/object/sign/audio%20receta/freepik_1080x1920_30fps_16352.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV80NDNkYTY1ZS1iYWM1LTQyYWQtODMzNS1iNWE4N2M0NDYxNmQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJhdWRpbyByZWNldGEvZnJlZXBpa18xMDgweDE5MjBfMzBmcHNfMTYzNTIubXA0IiwiaWF0IjoxNzcyNjcwMTAwLCJleHAiOjE4MDQyMDYxMDB9.b9wCY-opwUlDoEsHLJbYByugwDoMkIqeD53MAh0SX5Y#t=0.1" type="video/mp4" data-id="element-578" />
            Tu navegador no soporta la etiqueta de video.
          </video>
        </div>
      </div>
    </section>;
}